import Model from "./base/model";

class romaneioFile extends Model {
  resourceName() {
    return "romaneio_files";
  }

  fields() {
    return {
      path: "",
      name: "",
      stored_by: "",
      company: "",
      shipment_numbers: "",
    }
  }

  async updateRomaneio(data) {
    return this.request(
      `invoice/update/${this.resourceName()}/${data.id}`,
      "POST",
      {},
      data
    );
  }
}

export default new romaneioFile();